import { getAllLayers } from 'pxc-editor-core/helpers/schema';
import { getShieldBySelectedSection } from '@/helpers';

export default ({ shieldsSelection, pages, selectedSection }) => {
  let selectedShield = null;

  for (const shId in shieldsSelection) {
    const { shield } = getAllLayers(shId, pages);
    selectedShield = shield;
    break;
  }

  if (!selectedShield && selectedSection) {
    selectedShield = getShieldBySelectedSection({ pages, selectedSection });
  }

  return selectedShield;
};
